import { render, staticRenderFns } from "./EditAlert.vue?vue&type=template&id=45824e96&"
import script from "./EditAlert.vue?vue&type=script&lang=js&"
export * from "./EditAlert.vue?vue&type=script&lang=js&"
import style0 from "./EditAlert.vue?vue&type=style&index=0&id=45824e96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports